import React from "react";
import { Link } from "react-router-dom";

export default class LogoBox extends React.Component {
  render() {
    return (
      <>
        <div className="logo-box">
          <Link to={process.env.PUBLIC_URL + `/`}>
            <img
              src={
                "https://ik.imagekit.io/o0jwga39e/SK/skLogov2.png?updatedAt=1696761089068"
              }
              alt="Logo"
              style={{ width: "80px" }}
            />
          </Link>
        </div>
      </>
    );
  }
}
